/*
storage.const.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

export const localVar = {
    appGallerySettings: "appGallerySettings",
    userScanSettings: "userScanSettings",
    configurationSettings: "configurationSettings",
    recentEmailRecipients: "recentEmailRecipients",
    appName: "Autoredact",
    eulaAccepted: "eula-accepted"
}
export const sessionVar = {
    appStarted: "appStarted",
    deviceUrl: "deviceUrl",
    apiKey: "apiKey"
}